<div class="layout-column custom-panel full-width full-height">

  <!--Search Box-->
  <div class="layout-row layout-align-start-center padding-top-10 padding-left-10 padding-right-10 padding-bottom-5">

    <app-bringoz-search-input class="flex"
                              [placeholder]="ngPlaceholder"
                              [query]="queryString"
                              (queryChangeEvent)="onQueryChange($event)">

    </app-bringoz-search-input>


    <div *ngIf="!!accounts?.length && !cursor" class="layout-row layout-align-start-center margin-left-5">
      <app-bringoz-checkbox [isChecked]="accounts?.length === selectedAccountIds?.length"
                            (clickEvent)="onToggleSelectAll()">
      </app-bringoz-checkbox>

      <span class="br-body-2 font-weight-400 margin-left-5" translate>Select All</span>
    </div>

  </div>

  <hr class="main-divider">

  <div class="flex layout-column padding-left-10 padding-right-10">
    <cdk-virtual-scroll-viewport [itemSize]="25" class="flex viewport" (scroll)="getNextBatch()">
      <div *cdkVirtualFor="let account of accounts"
           layout="column"
           class="item">

        <div class="flex layout-row layout-align-start-center pointer"
             (click)="onToggle(account.id, selectedKeys[account.id])">
          <app-bringoz-checkbox class="margin-right-5"
                                [isChecked]="selectedKeys[account.id]">
          </app-bringoz-checkbox>
          <span class="br-body-2 font-weight-400">{{ account.name }}</span>
        </div>

      </div>
    </cdk-virtual-scroll-viewport>
  </div>

  <app-bringoz-linear-progress *ngIf="!!isLoading"></app-bringoz-linear-progress>

  <hr class="main-divider">

  <div class="layout-row layout-align-start-center padding-5">
    <bringoz-button [type]="'outline'"
                    [theme]="'primary'"
                    (onClick)="onReset();$event.stopPropagation();">
      <span>{{ 'Reset' | translate }}</span>
    </bringoz-button>
    <span class="flex"></span>
    <bringoz-button [type]="'tertiary'"
                    [theme]="'primary'"
                    (onClick)="onCancel();$event.stopPropagation();">
      <span>{{ 'Cancel' | translate }}</span>
    </bringoz-button>


    <bringoz-button [theme]="'secondary'"
                    (onClick)="onSubmit();$event.stopPropagation();">
      <span>{{ 'Submit' | translate }}</span>
    </bringoz-button>
  </div>

</div>
